import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { NotificationChannelPreference } from 'types/notification_channel';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseNotificationChannelPreferencesOptions = UseQueryOptions<
  NotificationChannelPreference[],
  APIError
> & {
  applicationId?: string;
};

export function useNotificationChannelPreferences({
  applicationId,
  ...options
}: UseNotificationChannelPreferencesOptions = {}) {
  const { applicationID: currentAppID, client } = useAPI();
  const appId = applicationId ?? currentAppID;

  return useAuthenticatedQuery(
    ['notification-channel-preferences', appId],
    async () => {
      const { data } = await client.get<NotificationChannelPreference[]>(
        `/apps/${appId}/notification_channel_preferences`
      );
      return data;
    },
    {
      enabled: Boolean(appId),
      ...options,
    }
  );
}
